export const useRadiusOfOperations = () => {
  return [0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550].sort((a, b) => a - b);
};
